// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1___0740c9ef17e52f02af2","cls2":"FeedbackModal-cls2__fb7caf63fb89b36bd216 FeedbackModal-cls1___0740c9ef17e52f02af2"};